const mockNotifications = [
  {
    id: 1,
    title: "Listing baru disetujui",
    message:
      "Properti 'Villa Harmoni Residence' sudah disetujui dan siap ditampilkan ke publik.",
    type: "success",
    read: false,
    createdAt: "2026-05-29T07:15:00Z",
    actionLabel: "Lihat detail",
    actionTo: "/dashboard/properties/1",
  },
  {
    id: 2,
    title: "Pesan masuk dari calon pembeli",
    message:
      "Ada 2 pesan baru untuk properti 'Green Valley House' yang belum dibaca.",
    type: "info",
    read: false,
    createdAt: "2026-05-29T06:42:00Z",
    actionLabel: "Buka pesan",
    actionTo: "/dashboard/messages",
  },
  {
    id: 3,
    title: "Foto properti perlu diperbarui",
    message:
      "Beberapa foto listing 'The Palm Estate' terdeteksi memiliki resolusi rendah.",
    type: "warning",
    read: true,
    createdAt: "2026-05-28T19:20:00Z",
    actionLabel: "Perbaiki",
    actionTo: "/dashboard/properties/4/edit",
  },
  {
    id: 4,
    title: "Verifikasi profil berhasil",
    message:
      "Profil akun Anda berhasil diverifikasi dan kini memiliki akses penuh.",
    type: "success",
    read: true,
    createdAt: "2026-05-28T14:05:00Z",
    actionLabel: "Lihat profil",
    actionTo: "/dashboard/profile",
  },
  {
    id: 5,
    title: "Pembayaran langganan jatuh tempo",
    message:
      "Langganan aktif Anda akan berakhir dalam 3 hari. Silakan perpanjang.",
    type: "danger",
    read: false,
    createdAt: "2026-05-29T04:10:00Z",
    actionLabel: "Perpanjang",
    actionTo: "/dashboard/subscriptions",
  },
];

export const getUnreadCount = (items = mockNotifications) =>
  items.filter((item) => !item.read).length;

export default mockNotifications;
